import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

class AccordionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.defaultActiveKey === props.accordionKey ? true : false
    };

    this.dynamicHeightHandling = this.dynamicHeightHandling.bind(this);
  }

  handleDocumentClick = event => {
    if (
      ReactDOM.findDOMNode(this).parentNode.contains(event.target) &&
      !ReactDOM.findDOMNode(this).contains(event.target) &&
      this.state.isExpanded
    ) {
      this.setState({ isExpanded: false });
    }
  };

  handleToggle = e => {
    e.preventDefault();
    this.setState({
      isExpanded: !this.state.isExpanded,
      // height: this.refs.inner.clientHeight
      height: "auto"
    });
    //this.refs.accordion.scrollIntoView();
  };

  dynamicHeightHandling = () => {
    this.setState({
      height: "auto"
    });
  };

  componentDidMount() {
    if (this.props.isAccordion) {
      document.addEventListener("click", this.handleDocumentClick, false);
      document.addEventListener("touchend", this.handleDocumentClick, false);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeCandidateId !== prevProps.activeCandidateId) {
      const isExpanded =
        this.props.defaultActiveKey === this.props.accordionKey ? true : false;
      this.setState({ isExpanded: isExpanded });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick, false);
    document.removeEventListener("touchend", this.handleDocumentClick, false);
  }

  render() {
    const { title, errorMsg, accordionKey, children } = this.props;
    const { isExpanded, height } = this.state;
    const isExpandedClass = isExpanded ? "expanded" : "";

    return (
      <div className="accordion-main" ref="accordion">
        <div
          id={accordionKey}
          className={`accordion-panel 
                    ${isExpanded ? "is-expanded" : ""}`}
          onClick={this.handleToggle}

        >
          <div className="accordion-panel-heading">
            <h1 className="profile-edit__section_h1">
              {title}
              {errorMsg ? (
                <span className="form-error-message">{errorMsg}</span>
              ) : null}
            </h1>
          </div>
        </div>
        <div className={"accordion-panel-collapse " + isExpandedClass}>
          <div
            className="accordion-panel-body"
            onClick={this.dynamicHeightHandling}
            ref="inner"
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

AccordionItem.propTypes = {
  title: PropTypes.string
};

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/components/UI/Accordion/AccordionItem.js